import { ProductAssets } from '@/types/product';
import { devtools } from 'zustand/middleware';
import { createWithEqualityFn } from 'zustand/traditional';

type State = {
  quantity: number;
  price: number;
  discountPrice: number;
  selectedOptions: Record<string, string>;
  allSelectedVariants: boolean;
  imageVariant: ProductAssets[];
  isApplicablePricebook: boolean;
};

type Actions = {
  setQuantity: (qty: number) => void;
  setPrice: (price: number) => void;
  setDiscountPrice: (price: number) => void;
  setSelectedOptions: (options: Record<string, string>) => void;
  setAllSelectedVariants: (v: boolean) => void;
  setImageVariant: (assets: ProductAssets[]) => void;
  setIsApplicablePricebook: (v: boolean) => void;
  reset: () => void;
};

const INITIAL: State = {
  quantity: 0,
  price: 0,
  discountPrice: 0,
  selectedOptions: {},
  allSelectedVariants: false,
  imageVariant: [],
  isApplicablePricebook: false,
};

export const useProductStore = createWithEqualityFn<State & Actions>()(
  devtools((set) => ({
    ...INITIAL,
    setQuantity: (qty) => set({ quantity: qty }),
    setDiscountPrice: (price) => set({ discountPrice: price }),
    setPrice: (price) => set({ price }),
    setSelectedOptions: (options) => set({ selectedOptions: options }),
    setAllSelectedVariants: (v) => set({ allSelectedVariants: v }),
    setImageVariant: (assets) => set({ imageVariant: assets }),
    setIsApplicablePricebook: (v) => set({ isApplicablePricebook: v }),
    reset: () => set({ ...INITIAL }, false, 'product/reset'),
  }))
);
